module.exports = __webpack_public_path__ + "img/kuota_tiket_cs.3dc21af3.svg";